import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Heading, Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';
import { cn } from '@restworld/utils-common';

export type ProposedJobApplicationModalProps = {
  show: boolean;
  onClose: () => void;
  jobPositionId?: string;
  restaurantId?: string;
  variant?: 'positive' | 'negative';
};

export const ProposedJobApplicationModal = ({
  show,
  onClose,
  jobPositionId,
  restaurantId,
  variant = 'positive',
}: ProposedJobApplicationModalProps) => {
  const { t } = useTranslation();
  const modalTitle =
    variant === 'positive'
      ? t('job-application-page:application_being_evaluated')
      : t('job-application-page:the_job_position_is_not_of_interest_to_you');
  const modalBody =
    variant === 'positive'
      ? t('job-application-page:application_being_evaluated_desc')
      : t('job-application-page:removed_the_job_position_from_the_proposals');
  return (
    <Modal open={show} onOpenChange={(v) => !v && onClose()}>
      <ModalContent className="w-full md:max-w-[26rem] md:min-w-[22rem]">
        <Wrapper>
          <CheckCircleIcon className="w-13 h-13 text-secondary-900 mb-4 " />
          <Heading size={3} align="center" className="leading-7 mb-2">
            {modalTitle}
          </Heading>
          <Heading size={5} color="muted" align="center" className="mb-10">
            {modalBody}
          </Heading>
          <div className="flex flex-col items-center w-full gap-4 ">
            {variant === 'positive' && (
              <NextLink
                href={`/candidature/${restaurantId || jobPositionId}`}
                className="text-primary-800 cursor-pointer w-full"
              >
                <Button fullwidth variant="primary">
                  {t('job-application-page:view_candidate')}
                </Button>
              </NextLink>
            )}
            <Button fullwidth variant={variant === 'positive' ? 'secondary-neutral' : 'primary'} onClick={onClose}>
              {t('common:close')}
            </Button>
          </div>
        </Wrapper>
      </ModalContent>
    </Modal>
  );
};

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col items-center', className)} {...props} />
);
